import * as React from 'react';
import { cn } from '@/lib/utils';

// ---------------------------------------------------------------------------
// The page kit's three widths (web app v4 plan, Phase 3), in place of the
// seven pages used to pick for themselves:
//   narrow   Settings, and single-column forms and reading
//   default  everything else
//   full     the calendar, which uses the whole width
// The app shell's <main> supplies the padding, so a page adds none of its own.
// ---------------------------------------------------------------------------

export type PageWidth = 'narrow' | 'default' | 'full';

export const PAGE_WIDTH_CLASS: Record<PageWidth, string> = {
  narrow: 'max-w-[960px]',
  default: 'max-w-[1280px]',
  full: 'max-w-none',
};

export function PageContainer({ width = 'default', className, children, ...props }:
  React.HTMLAttributes<HTMLDivElement> & { width?: PageWidth }) {
  return (
    <div className={cn('mx-auto w-full min-w-0', PAGE_WIDTH_CLASS[width], className)} {...props}>
      {children}
    </div>
  );
}
